<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Send Money</p>
                        <!--<p class="sub">From me to me</p>-->
                        <p class="sub">From me to me</p>
                    </div>
                </div>
            </div>


            <!--        Intro Text-->
            <div class="form-component">

                <div class="card mb-4">
                    <div class="card-body">
                        <!--<div class="card-title">From Me TO Me</div>-->
                        <div class="card-title">From me to me</div>
                        <!--<p>-->
                        <!--{{getFullBankList}}-->
                        <!--</p>-->
                        <div class="card-content">
                            <form @submit.prevent="fundsTransferStep1">
                                <div class="alert-box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                {{alert.message}}
                                            </ui-alert>
                                        </div>
                                    </div>
                                </div>

                                <!--<form>-->
                                <div class="row">
                                    <div class="col-md-6 form-group mb-2">
                                        <!--<accounts-select-box></accounts-select-box>-->
                                        <label>Debit Account*</label>
                                        <ui-select
                                                ref="debitAccountSelect"
                                                placeholder="Select Debit Account"
                                                type="basic"
                                                :options="dat"
                                                error="You must select at least 1 colours"
                                                :invalid="debitAcctTouched && debitAcct.length < 1"
                                                @touch="debitAcctTouched = true"
                                                v-model="debitAcct"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label>Credit Account*</label>
                                        <ui-select
                                                ref="debitAccountSelect"
                                                placeholder="Select Credit Account"
                                                type="basic"
                                                :options="dat"
                                                error="You must select at least 1 colours"
                                                :invalid="creditAcctTouched && creditAcct.length < 1"
                                                @touch="creditAcctTouched = true"
                                                v-model="creditAcct"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label for="amount">Amount*</label>
                                        <div class="amount-input">
                                            <div class="currency">
                                                <span>&#8358;</span>
                                            </div>

                                            <input
                                                    type="text" id="amount" class="input"
                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                    v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                    @change="amountOnChange(amount)"
                                            >
                                        </div>

                                        <span v-show="errors.has('amount')" class="error-span is-danger">{{ errors.first('amount') }}</span>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <!---->
                                    </div>

                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-xnax push-right">Next</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>



        <!--Confirmation modal-->
        <ui-modal
                ref="confirmationModal" transition="scale-up"
                :removeHeader= "true" size="small"
                align-top :align-top-margin="150"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body history">
                        <div class="row">
                            <div class="col-sm-12">

                                <div class="confirmationModal">
                                    <h4>Transfer Confirmation</h4>

                                    <p>
                                        You're about to Move
                                        <span class="currency">&#8358;</span>
                                        <span class="amt">{{postBody.amount | moneyToDecimal}}</span>
                                        from
                                        <span class="acct">{{postBody.debitAcct.value.accountno}}</span>
                                        to
                                        <span class="acct">{{postBody.creditAcct.value.accountno}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="meToMeFundsTransfer()" class="btn btn-primary btn-xnax-login ">Confirm</button>
                    </div>
                </div>
            </div>
        </ui-modal>


        <!--UI Modal For Displaying Transfer Success Message-->
        <ui-modal
                ref="transferSuccessModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                            <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                            <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Congratulations!! <br>
                                        {{successMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>

        <!--UI Modal For Displaying Transfer Failed Message-->
        <ui-modal
                ref="transferFailModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <!--<svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">-->
                                        <!--<circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>-->
                                        <!--<path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>-->
                                        <!--<path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>-->
                                        <!--</svg>-->
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                            <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                                            <polyline points="16 34 25 25 34 16 " class="svgA"></polyline>
                                            <polyline points="16 16 25 25 34 34 " class="svgA"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Failed!! <br>
                                        {{errorMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import VueTelInput from 'vue-tel-input';
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";



    export default {
        name: "phoneTransfer",
        components: {
            FooterMobile,
            VueTelInput,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                debitAcct:  '',
                debitAcctTouched:  false,
                creditAcct:  '',
                creditAcctTouched:  false,
                narration: '',
                amount: '',

                postBody: {
                    amount: '',
                    debitAcct: {
                        label: '',
                        value: {
                            accountno: ''
                        }
                    },
                    creditAcct: {
                        label: '',
                        value: {
                            accountno: ''
                        }
                    }
                },

                successMessage: '',
                errorMessage: '',

                dat: [],


                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getFullBankList',
                'getUsername',
            ])
        },
        created () {
            this.popDebitAcct()
        },
        methods: {
            ...mapActions([
                'updateNetworkErrorState',
                'updateSideBarPage',
                'updateAppLoading',
                'updateInsideCurrentPage',
                'updateConfirmationPageBody',
                'updateDataOnLoginAccounts',
                'updateDataOnLoginTransactions',
            ]),

            backButton(){
                this.updateInsideCurrentPage('sendMoney')
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },
            confirmationModalHide(){
                // console.log('Confirmation Modal Hidden')
            },

            openTransferSuccessModal(){
                //Open The TransferSuccessModal
                this.openModal('transferSuccessModal');
            },
            closeTransferSuccessModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferSuccessModal')
            },
            openTransferFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeTransferFailModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal')
            },


            generateUUID () {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },

            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },

            clearKeenUiSelect(ref) {
                this.$refs[ref].clearSelection();
            },
            FTResetAllInputField(){
                this.debitAcct = "";
                this.creditAcct= '';
                this.amount= '';
                this.narration= '';

                this.postBody = {};
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },

            fundsTransferStep1(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if (this.creditAcct === undefined || this.creditAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Credit Account*')
                }
                else if (this.creditAcct.label === this.debitAcct.label){
                    // display error notification
                    this.showAlert(true, 'error', "Debit Account can't be the same as Credit Account*")
                }
                else {
                    this.alert.show = false;
                    // this.saveDetailsForNameEnquiry()

                    this.postBody.debitAcct = this.debitAcct;
                    this.postBody.creditAcct = this.creditAcct;
                    this.postBody.amount = this.amount;

                    // console.log('POST BODY', this.postBody);

                    this.openModal('confirmationModal')
                }

            },
            meToMeFundsTransfer(){
                //start app running
                this.updateAppLoading(true);

                let dataToBeSent = {
                    amount: this.cleanAmount(this.amount),
                    draccount: this.debitAcct.value.accountno,
                    savebene: 'N',
                    source: "WEB",
                    craccount: this.creditAcct.value.accountno,
                    pin: '',
                    reference: this.generateUUID() + '-' + this.getDataOnLogin.customerid.replace(/\s/g, ''),
                    customerid: this.getDataOnLogin.customerid,
                    alias: '',
                    craccountname: this.creditAcct.value.accountname,
                    bankcode: "090175",
                    bankname: "HighStreet MFB",
                    draccountname: this.debitAcct.value.accountname,
                    username: this.getUsername,
                    narration: 'Self Transfer from ' + this.debitAcct.value.accountno + ' to ' + this.creditAcct.value.accountno,
                };
                // console.log('Data To Be Sent =>>>>', dataToBeSent);

                axios
                    .post('/fundtransfer', dataToBeSent,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData = response.data;
                        console.table(responseData);

                        if (responseData.responsecode === '00') {
                            // console.log('TRANSFER SUCCESS');


                            // equate the response message and show transferSuccessModal
                            this.successMessage = responseData.responsemessage;
                            this.openTransferSuccessModal();

                            // update dataOnLogin in the store appropriately
                            this.updateDataOnLoginAccounts(responseData.accountlist);
                            this.updateDataOnLoginTransactions(responseData.transactionlist);

                        } else {
                            // console.log('Other Errors');

                            // equate the response message and show transferFailModal
                            this.errorMessage = responseData.responsemessage;
                            this.openTransferFailModal();
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);

                        // set network error state to true
                        this.updateNetworkErrorState(true);
                    })
            },

            endTransfer(){
                // console.log('Success Modal Hide')
                //Update the current sub component in the store
                this.updateInsideCurrentPage('dashboard')
                this.updateSideBarPage('dashboard');
            },
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
    .selectWrapper{
        border-radius: 20px;
        display: block;
        overflow: hidden;
        background: #f4f6fa;
        border: none;
        padding: 0 8px;
    }
    .selectBox{
        background-color: transparent !important;
    }
    .selectBox:focus{
        box-shadow: none;
    }

    .amount-input{
        display: flex;
        background-color: #f4f6fa;
        border-radius: 20px;
        border: 1px solid #f0f3f8;
    }
    .amount-input .currency{
        padding: 9px 8px 8px 15px;
        font-size: 12px;
        line-height: 13px;
    }
    .amount-input .currency span{
        font-weight: 600;
        color: #171717;
    }
    .amount-input .input{
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        font-size: 12px;
        outline: none;
        padding: 0 15px 0 5px;
        border-bottom-right-radius: 20px;
        border-top-right-radius: 20px;
    }
    .amount-input .input:focus,
    .amount-input .input:active {
        background-color: #FFFFFF;
    }



    .confirmationModal{}
    .confirmationModal h4{
        font-size: 12px;
        /* font-weight: 800; */
        margin-bottom: 15px;
    }
    .confirmationModal p{}
    .confirmationModal p .currency{
        font-size: 12px;
        font-weight: 900;
    }
    .confirmationModal p .amt{
        /*color: #6d0606;*/
        font-size: 12px;
        font-weight: 900;
    }
    .confirmationModal p .acct{
        color: #6d0606;
        padding: 0 2px;
        font-size: 12px;
        font-weight: 900;
    }
    /*.selectBox{border-radius:4px;border:1px solid #AAAAAA;}*/
</style>